import { ACCEPTED_TYPES } from '@/constants/media';

const MAX_BASE_LENGTH = 60;

/**
 * Turn an arbitrary user filename into a safe, portable base name:
 * strips any path components and extension, removes control characters,
 * and collapses everything outside [a-z0-9-_] into single dashes.
 */
export function sanitizeBaseName(fileName: string): string {
  const lastSegment = fileName.split(/[\\/]/).pop() ?? '';
  const withoutExt = lastSegment.replace(/\.[^.]*$/, '');
  const cleaned = withoutExt
    .toLowerCase()
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u001f\u007f]/g, '')
    .replace(/[^a-z0-9-_]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^[-_]+|[-_]+$/g, '')
    .slice(0, MAX_BASE_LENGTH);
  return cleaned.length > 0 ? cleaned : 'clip';
}

/**
 * Pick a safe extension for the in-worker input file. FFmpeg mostly probes by
 * content, but a sensible extension keeps demuxer selection predictable.
 */
export function safeInputExtension(mimeType: string, fileName: string): string {
  const byType = ACCEPTED_TYPES[mimeType]?.[0];
  if (byType) return byType;
  const match = /\.([a-z0-9]{2,5})$/i.exec(fileName);
  const ext = match?.[1]?.toLowerCase();
  if (ext && Object.values(ACCEPTED_TYPES).some((list) => list.includes(`.${ext}`))) {
    return `.${ext}`;
  }
  return '.mp4';
}

export function buildOutputName(
  sourceName: string,
  width: number,
  height: number,
  fps: number,
): string {
  return `${sanitizeBaseName(sourceName)}-${width}x${height}-${fps}fps.gif`;
}
